import analysis from './en-US/analysis';
import app from './en-US/app';
import common from './en-US/common';
import component from './en-US/component';
import dashboard from './en-US/dashboard';
import data from './en-US/data';
import globalHeader from './en-US/globalHeader';
import landing from './en-US/landing';
import menu from './en-US/menu';
import org from './en-US/org';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import system from './en-US/system';
import user from './en-US/user';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...user,
  ...landing,
  ...menu,
  ...dashboard,
  ...app,
  ...data,
  ...analysis,
  ...org,
  ...system,
  ...common,
  ...globalHeader,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
};
